import React from 'react'
import { useStore } from '@/models'
import { GameSetupScreen } from '@/screens/GameContainer/GameSetupScreen'

export default function PracticeSetupScreen() {
  const { user } = useStore().session

  const userId = user?.auth0Id || 'guest'
  const userName = user?.name || 'Guest Player'

  return <GameSetupScreen userId={userId} userName={userName} />
}
